<template>
  <span>Ops... Senha incorreta!</span>
</template>

<script>
  export default {
    name: 'login-notification-template'
  }
</script>
